/* eslint-disable import/no-extraneous-dependencies, arrow-body-style,object-curly-newline */
import RefHoc from 'platform/react/hoc/pubsub/ref'
import Section from 'ui/Element/Section'

const SubbedRefSection = RefHoc(Section)

export default SubbedRefSection
